import React from 'react';

const FilterSearchInput = ({
  value,
  onChange,
  placeholder = 'Filter',
  id = 'filter-dropdown-input',
  autoFocus = false,
  icon = 'F',
  className = '',
}) => {
  return (
    <div className="relative">
      <input
        type="text"
        value={value}
        onChange={onChange}
        autoFocus={autoFocus}
        id={id}
        placeholder={placeholder}
        className={`w-full bg-transparent text-white px-3.5 py-2.5 border-b border-[rgba(255,255,255,0.1)] outline-none ${className}`}
      />
      <div className="absolute right-3.5 top-1/2 -translate-y-1/2 text-[#D2D3E0] bg-[#393a45] h-4 w-4 text-center rounded-[3px] font-inter">
        {icon}
      </div>
    </div>
  );
};

export default FilterSearchInput;
